import {
  sanitizeArr
} from '../../Array.lib';
import {
  upsertConfiguration
} from '../../Configuration.lib';
import globalErrorHandler from '../../Error/globalErrorHandler.fun';
import {
  Obj
} from '../../Object.lib';
import fetchResumeHighlightsConfiguration from './fetchResumeHighlightsConfiguration.fun';

export default async function upsertResumeHighlightsList({
  attribute,
  list
}) {
  try {
    const configuration = Obj(
      await fetchResumeHighlightsConfiguration()
    );
    configuration.value[attribute] = sanitizeArr(list).sort();
    await upsertConfiguration(configuration)
  }
  catch (error) {
    globalErrorHandler(error);
  }
}
